/**
 * Banned appraisers registry API (frontend_documentation/banned-appraisers.md).
 * A GLOBAL admin list of appraisers the desk won't accept. Each record is a
 * LoanContact (loanRole "Appraiser" + appraiserLicenseNumber) plus ban metadata,
 * deduped server-side by registryKey (license, else name/company slug).
 *
 * TWO ROUTERS, deliberately (moved 2026-08-13):
 *   MANAGEMENT — `/admin/data/banned-appraisers`, **admin-gated** (`require_admin`;
 *     a non-admin gets 403). List / add / edit / remove live here, alongside the
 *     other reference-data admin surfaces.
 *   CHECK — `/loan-processing/banned-appraisers/check`, plain auth. It stays off
 *     the admin router on purpose: the appraisal-review workflow calls it
 *     mid-review, and those reviewers are not admins.
 * The old `/loan-processing` list/add/edit/delete routes are GONE — don't
 * repoint anything back to them.
 *
 * Add/Edit bodies are a LoanContact shape; do NOT send `_id`, `registryKey`,
 * `normalizedLicenseNumber`, or `createdAt` (all server-derived). Add upserts on
 * the license; Edit is partial (changed fields only).
 */
import { losHttp } from "../lib/losHttp";

const ADMIN = "/admin/data/banned-appraisers";
const WORKFLOW = "/loan-processing/banned-appraisers";

export const losBannedAppraisersApi = {
  // GET /admin/data/banned-appraisers → BannedAppraiser[] (sorted by name)
  list: () => losHttp.get(ADMIN).then((r) => r.data?.bannedAppraisers || []),

  // GET /loan-processing/banned-appraisers/check?license= → { banned, match }
  // The workflow lookup — plain auth, so appraisal reviewers can call it.
  check: (license) =>
    losHttp.get(`${WORKFLOW}/check`, { params: { license } }).then((r) => r.data),

  // GET /admin/data/banned-appraisers/check?license= — the admin mirror of the
  // same lookup, for use from an admin surface that already has the gate.
  checkAsAdmin: (license) =>
    losHttp.get(`${ADMIN}/check`, { params: { license } }).then((r) => r.data),

  // POST /admin/data/banned-appraisers → 201 the created/updated record
  add: (body) => losHttp.post(ADMIN, body).then((r) => r.data),

  // PUT /admin/data/banned-appraisers/{appraiserId} → the updated record
  edit: (appraiserId, body) =>
    losHttp.put(`${ADMIN}/${appraiserId}`, body).then((r) => r.data),

  // DELETE /admin/data/banned-appraisers/{appraiserId} → { removed, id }
  remove: (appraiserId) =>
    losHttp.delete(`${ADMIN}/${appraiserId}`).then((r) => r.data),
};

export default losBannedAppraisersApi;
